module.exports = __webpack_public_path__ + "static/09-c1a962ca47aad2f27d7079bf571c4ef3.jpg";